import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useApi } from '../../contexts/ApiContext'
import { useAuth } from '../../contexts/AuthContext'
import axios from 'axios'
import { apiService } from '../../services/apiService'
import { 
  LayoutDashboard, 
  MessageSquare, 
  Users, 
  Settings,
  Menu,
  X,
  Bell,
  Search,
  User,
  ChevronDown,
  ChevronRight,
  LogOut,
  Wifi,
  WifiOff,
  Calendar, 
  QrCode,
  ListChecks,
  DollarSign,
  Shield,
  TrendingUp,
  Key,
  Eye,
  EyeOff,
  AlertCircle,
  CheckCircle,
  AlertTriangle,
  FileText,
  Package,
  Lightbulb,
  ShoppingCart,
  RefreshCw
} from 'lucide-react'

const PAPERLESS_ULTIMO_VISTO_KEY = 'paperless_ultimo_documento_visto'

const menuItems = [
  {
    path: '/dashboard',
    icon: LayoutDashboard,
    label: 'Dashboard',
    description: 'Visão geral do sistema'
  },
  {
    icon: MessageSquare,
    label: 'Cobranças',
    description: 'WhatsApp e Agenda',
    children: [
      {
        path: '/lembretes',
        label: 'Lembretes',
        description: 'Agendamentos do dia'
      },
      {
        path: '/cobranca-whatsapp',
        label: 'Cobrança WhatsApp',
        description: ''
      },
      {
        path: '/agenda-cobrancas',
        label: 'Agenda de Cobranças',
        description: 'Organize suas visitas'
      }
    ]
  },
  {
    icon: QrCode,
    label: 'PIX',
    description: 'Cobranças e links PIX',
    children: [
      {
        path: '/cobranca-pix',
        label: 'Cobrança PIX',
        description: 'Gerar links de pagamento'
      },
      {
        path: '/link-pix-aleatorio',
        label: 'Link PIX Aleatório',
        description: 'Links com valores personalizados'
      },
      {
        path: '/lista-pix',
        label: 'Lista PIX Emitidos',
        description: 'Acompanhe pagamentos'
      }
    ]
  },
  {
    icon: DollarSign,
    label: 'Conciliação',
    description: 'PIX e Caixa',
    children: [
      {
        path: '/conciliacao-pix',
        label: 'Conciliação PIX',
        description: 'Vincular pagamentos PIX'
      },
      {
        path: '/conciliacao-caixa',
        label: 'Conciliação Caixa',
        description: 'Recebimentos do caixa'
      }
    ]
  },
  {
    icon: Shield,
    label: 'Crediário',
    description: 'Análise e viabilidade de venda',
    children: [
      {
        path: '/analise-credito',
        label: 'Análise de Crédito',
        description: 'Avaliação de crediário'
      },
      {
        path: '/simulador-viabilidade',
        label: 'Simulador de Viabilidade',
        description: 'Viabilidade financeira de desconto',
        gerenteOuAdmin: true
      }
    ]
  },
  {
    icon: TrendingUp,
    label: 'Crediário Rotativo',
    description: 'Score e alertas de crédito',
    children: [
      {
        path: '/crediario-rotativo',
        label: 'Cálculo de Escore',
        description: 'Score comportamental dos clientes'
      },
      {
        path: '/crediario-alertas',
        label: 'Alertas',
        description: 'Limites liberados e notificações'
      },
    ]
  },
  {
    icon: AlertTriangle,
    label: 'Notificações',
    description: 'Alertas de preço e margem',
    children: [
      {
        path: '/logs-erros',
        label: 'Logs',
        description: 'Preço zerado, margem insuficiente e descrição de produto'
      },
      {
        path: '/margens',
        label: 'Margens',
        description: 'Markup mínimo por tabela e categoria'
      },
      {
        path: '/margens-lucro-juros',
        label: 'Margens Lucro/Juros',
        description: 'Margem praticada em cada venda',
        adminOnly: true,
        ocultoSemAcesso: true
      },
      {
        path: '/whatsapp-automacao',
        label: 'Whatsapp Automação',
        description: 'Horário e texto do grupo de ofertas'
      }
    ]
  },
  {
    icon: Package,
    label: 'Produtos',
    description: 'Cadastro, preços e estoque',
    children: [
      {
        path: '/estoque-min-ideal',
        label: 'Estoque Ideal',
        description: 'GMM, grupo de compra e níveis de estoque mínimo/ideal',
        gerenteOuAdmin: true
      },
      {
        path: '/inventario-rotativo',
        label: 'Inventário Rotativo',
        description: 'Rodadas de contagem cíclica com folha de impressão',
        gerenteOuAdmin: true
      },
      {
        path: '/estoque-celulares',
        label: 'Estoque de Celulares',
        description: 'Controle por IMEI × ERP e vendas por mês',
        gerenteOuAdmin: true
      },
      {
        path: '/avaliacao-compra',
        label: 'Compras IA',
        description: 'Avaliação de compra de produto novo com IA',
        gerenteOuAdmin: true
      },
      {
        path: '/pwa/consultas',
        label: 'Consultas do PWA',
        description: 'Avisos dos vendedores e produtos mais consultados',
        gerenteOuAdmin: true
      },
      {
        path: '/produtos/correcao-descricao',
        label: 'Correção Descrição',
        description: 'Revisão das descrições de produtos'
      }
    ]
  },
  {
    icon: ShoppingCart,
    label: 'Pedidos',
    description: 'Compras e precificação',
    children: [
      {
        path: '/pedidos/precificacao',
        label: 'Precificação',
        description: 'Custo do produto a partir da NF-e',
        gerenteOuAdmin: true
      }
    ]
  },
  {
    icon: RefreshCw,
    label: 'Sincronização',
    description: 'Histórico das integrações',
    children: [
      {
        path: '/sincronizacao/logs',
        label: 'Logs de Sincronização',
        description: 'Execuções, alterações e erros',
        gerenteOuAdmin: true
      }
    ]
  },
  {
    icon: Settings,
    label: 'Configurações',
    description: 'Sistema e integrações',
    children: [
      {
        path: '/configuracoes',
        label: 'Configurações',
        description: 'Sistema e integrações'
      },
      {
        path: '/gerenciar-usuarios',
        label: 'Gerenciar Usuários',
        description: 'Controle de acesso',
        adminOnly: true
      }
    ]
  },
  {
    path: '/arquivos-escaneados',
    icon: FileText,
    label: 'Arquivos Scaneados',
    description: 'Documentos no Paperless'
  }
]

// Páginas acessadas fora do menu lateral (ex.: atalho no header) — só para o título do header.
const paginasForaDoMenu = [
  { path: '/ideias', label: 'Caixa de Ideias' }
]

// ============================================
// MODAL DE TROCA DE SENHA
// ============================================
function ModalTrocarSenha({ isOpen, onClose, usuario }) {
  const [senhaAtual, setSenhaAtual] = useState('')
  const [senhaNova, setSenhaNova] = useState('')
  const [senhaConfirmar, setSenhaConfirmar] = useState('')
  const [mostrarSenhaAtual, setMostrarSenhaAtual] = useState(false)
  const [mostrarSenhaNova, setMostrarSenhaNova] = useState(false)
  const [mostrarSenhaConfirmar, setMostrarSenhaConfirmar] = useState(false)
  const [loading, setLoading] = useState(false)
  const [erro, setErro] = useState('')
  const [sucesso, setSucesso] = useState(false)

  const resetForm = () => {
    setSenhaAtual('')
    setSenhaNova('')
    setSenhaConfirmar('')
    setErro('')
    setSucesso(false)
    setMostrarSenhaAtual(false)
    setMostrarSenhaNova(false)
    setMostrarSenhaConfirmar(false)
  }

  const handleClose = () => {
    resetForm()
    onClose()
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErro('')
    setSucesso(false)

    if (!senhaAtual || !senhaNova || !senhaConfirmar) {
      setErro('Todos os campos são obrigatórios')
      return
    }
    if (senhaNova.length < 6) {
      setErro('A nova senha deve ter no mínimo 6 caracteres')
      return
    }
    if (senhaNova !== senhaConfirmar) {
      setErro('As senhas não coincidem')
      return
    }
    if (senhaAtual === senhaNova) {
      setErro('A nova senha deve ser diferente da senha atual')
      return
    }

    setLoading(true)

    try {
      const token = localStorage.getItem('token')
      
      const getApiUrl = () => {
        const isProduction = import.meta.env.VITE_PRODUCAO === 'true'
        if (isProduction) return '/api'
        const devUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001'
        if (!devUrl.endsWith('/api')) return devUrl + '/api'
        return devUrl
      }

      const apiUrl = getApiUrl()
      const urlCompleta = `${apiUrl}/auth/usuarios/${usuario.id}/senha`

      const response = await axios.put(
        urlCompleta,
        { senha_atual: senhaAtual, senha_nova: senhaNova },
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      )

      if (response.data.sucesso) {
        setSucesso(true)
        setTimeout(() => { handleClose() }, 2000)
      } else {
        setErro(response.data.mensagem || 'Erro ao alterar senha')
      }
    } catch (error) {
      console.error('Erro ao alterar senha:', error)
      setErro(error.response?.data?.mensagem || 'Erro ao alterar senha. Verifique se a senha atual está correta.')
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <>
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
        onClick={handleClose}
      >
        <div 
          className="bg-white rounded-xl shadow-2xl max-w-md w-full"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between p-6 border-b border-gray-200">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <Key className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Trocar Senha</h3>
                <p className="text-sm text-gray-500">Altere sua senha de acesso</p>
              </div>
            </div>
            <button onClick={handleClose} className="p-2 hover:bg-gray-100 rounded-lg transition-colors" disabled={loading}>
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            {erro && (
              <div className="flex items-start space-x-3 p-4 bg-red-50 border border-red-200 rounded-lg">
                <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-red-700">{erro}</p>
              </div>
            )}
            {sucesso && (
              <div className="flex items-start space-x-3 p-4 bg-green-50 border border-green-200 rounded-lg">
                <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-green-700">Senha alterada com sucesso!</p>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Senha Atual *</label>
              <div className="relative">
                <input type={mostrarSenhaAtual ? 'text' : 'password'} value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Digite sua senha atual" disabled={loading || sucesso} required />
                <button type="button" onClick={() => setMostrarSenhaAtual(!mostrarSenhaAtual)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600" tabIndex={-1}>
                  {mostrarSenhaAtual ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Nova Senha *</label>
              <div className="relative">
                <input type={mostrarSenhaNova ? 'text' : 'password'} value={senhaNova} onChange={(e) => setSenhaNova(e.target.value)} className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Digite a nova senha" disabled={loading || sucesso} required minLength={6} />
                <button type="button" onClick={() => setMostrarSenhaNova(!mostrarSenhaNova)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600" tabIndex={-1}>
                  {mostrarSenhaNova ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
              <p className="text-xs text-gray-500 mt-1">Mínimo de 6 caracteres</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Confirmar Nova Senha *</label>
              <div className="relative">
                <input type={mostrarSenhaConfirmar ? 'text' : 'password'} value={senhaConfirmar} onChange={(e) => setSenhaConfirmar(e.target.value)} className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Digite a nova senha novamente" disabled={loading || sucesso} required minLength={6} />
                <button type="button" onClick={() => setMostrarSenhaConfirmar(!mostrarSenhaConfirmar)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600" tabIndex={-1}>
                  {mostrarSenhaConfirmar ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            <div className="flex items-center space-x-3 pt-4">
              <button type="button" onClick={handleClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium" disabled={loading}>Cancelar</button>
              <button type="submit" className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium disabled:bg-gray-300 disabled:cursor-not-allowed" disabled={loading || sucesso}>
                {loading ? 'Salvando...' : 'Salvar Senha'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

// ============================================
// COMPONENTE PRINCIPAL LAYOUT
// ============================================
export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const [modalSenhaOpen, setModalSenhaOpen] = useState(false)
  const location = useLocation()
  const [openDropdowns, setOpenDropdowns] = useState(() => {
    const initial = {}
    if (location.pathname.includes('conciliacao') || location.pathname.includes('baixa-pix')) initial['Conciliação'] = true
    if (location.pathname.includes('lembretes') || location.pathname.includes('cobranca-whatsapp') || location.pathname.includes('agenda-cobrancas')) initial['Cobranças'] = true
    if (location.pathname.includes('crediario')) initial['Crediário Rotativo'] = true
    if (location.pathname.includes('analise-credito') || location.pathname.includes('simulador-viabilidade')) initial['Crediário'] = true
    if (location.pathname.includes('cobranca-pix') || location.pathname.includes('link-pix-aleatorio') || location.pathname.includes('lista-pix')) initial['PIX'] = true
    if (location.pathname.includes('/produtos/correcao-descricao') || location.pathname.includes('/pwa/consultas') || location.pathname.includes('estoque-min-ideal') || location.pathname.includes('inventario-rotativo') || location.pathname.includes('estoque-celulares') || location.pathname.includes('avaliacao-compra')) initial['Produtos'] = true
    if (location.pathname.includes('/sincronizacao')) initial['Sincronização'] = true
    if (location.pathname.includes('/pedidos')) initial['Pedidos'] = true
    return initial
  })
  const navigate = useNavigate()
  const { whatsappStatus } = useApi()
  const { usuario, logout, isAdmin, isGerenteOuAdmin } = useAuth()

  const isActive = (path) => location.pathname === path

  const currentPage = (() => {
    for (const item of menuItems) {
      if (item.path && isActive(item.path)) return item
      if (item.children) {
        const child = item.children.find(c => isActive(c.path))
        if (child) return child
      }
    }
    return paginasForaDoMenu.find(p => isActive(p.path)) || null
  })()

  const [ideiasPendentes, setIdeiasPendentes] = useState(0)
  const [ideiasNaoLidas, setIdeiasNaoLidas] = useState(false)
  const gestor = isGerenteOuAdmin()

  // Luz vermelha na lâmpada do header (só gestores): aparece enquanto houver ideias com status 'nova'
  // e pisca até o gestor abrir a Caixa de Ideias. "Lida" = já viu a ideia mais recente (guardado por usuário no navegador).
  useEffect(() => {
    if (!gestor) return
    let cancelado = false
    const chaveVista = `ideias_ultima_vista_${usuario?.id}`

    async function verificarIdeiasPendentes() {
      try {
        const { data } = await apiService.ideias.pendentes()
        if (cancelado) return
        const ultima = data.ultima_criada_em || null
        let vista = null
        try { vista = localStorage.getItem(chaveVista) } catch { /* storage indisponível */ }
        if (ultima && location.pathname.startsWith('/ideias')) {
          try { localStorage.setItem(chaveVista, ultima) } catch { /* storage indisponível */ }
          vista = ultima
        }
        setIdeiasPendentes(data.total || 0)
        setIdeiasNaoLidas(!!ultima && (!vista || new Date(ultima) > new Date(vista)))
      } catch {
        // silencioso: não bloqueia o header por causa dessa checagem
      }
    }

    verificarIdeiasPendentes()
    const intervalo = setInterval(verificarIdeiasPendentes, 3 * 60 * 1000)

    return () => {
      cancelado = true
      clearInterval(intervalo)
    }
  }, [location.pathname, gestor, usuario?.id])

  const [temNovosArquivosScaneados, setTemNovosArquivosScaneados] = useState(false)

  useEffect(() => {
    let cancelado = false

    async function verificarNovosArquivosScaneados() {
      try {
        const { data } = await apiService.paperless.getRecentes(1)
        const maisRecente = data.documentos?.[0]
        if (!maisRecente || cancelado) return

        const ultimoVisto = localStorage.getItem(PAPERLESS_ULTIMO_VISTO_KEY)
        const houveNovo = !ultimoVisto || new Date(maisRecente.criadoEm) > new Date(ultimoVisto)
        setTemNovosArquivosScaneados(houveNovo)
      } catch {
        // silencioso: não bloqueia o uso do menu por causa dessa checagem
      }
    }

    verificarNovosArquivosScaneados()
    const intervalo = setInterval(verificarNovosArquivosScaneados, 3 * 60 * 1000)

    return () => {
      cancelado = true
      clearInterval(intervalo)
    }
  }, [location.pathname])

  const handleLogout = async () => {
    if (window.confirm('Deseja realmente sair do sistema?')) {
      await logout()
      navigate('/login')
    }
  }

  const handleAbrirModalSenha = () => {
    setUserMenuOpen(false)
    setModalSenhaOpen(true)
  }

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <ModalTrocarSenha 
        isOpen={modalSenhaOpen}
        onClose={() => setModalSenhaOpen(false)}
        usuario={usuario}
      />

      {/* Sidebar */}
      <aside
        className={`
          fixed inset-y-0 left-0 z-50 w-72 h-screen flex flex-col bg-gradient-to-b from-blue-900 to-blue-800 
          transform transition-transform duration-300 ease-in-out
          lg:translate-x-0 lg:static lg:inset-0
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >
        {/* Logo/Brand */}
        <div className="flex-shrink-0 flex items-center justify-between h-14 px-5 border-b border-blue-700">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center shadow-lg">
              <LayoutDashboard className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-white leading-tight">Cobrança ERP</h1>
              <p className="text-xs text-blue-200 leading-tight">Sistema Integrado</p>
            </div>
          </div>
          <button onClick={() => setSidebarOpen(false)} className="lg:hidden p-2 rounded-lg text-blue-200 hover:bg-blue-700 transition-colors">
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* User Info Card */}
        <div className="flex-shrink-0 px-4 py-2 border-b border-blue-700">
          <div className="bg-blue-700 rounded-lg px-3 py-2">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center shadow-lg flex-shrink-0">
                <User className="w-5 h-5 text-white" />
              </div>
              <div className="flex-1 min-w-0 flex items-center justify-between gap-2">
                <p className="text-sm font-medium text-white truncate">
                  {usuario?.nome_completo || usuario?.username || 'Usuário'}
                </p>
                <div className="flex items-center flex-shrink-0">
                  {isAdmin() ? (
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-purple-400/30 text-purple-100">
                      <Shield className="w-3 h-3" />Admin
                    </span>
                  ) : (
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-400/30 text-blue-100">
                      Usuário
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="flex-1 min-h-0 px-4 py-3 space-y-1 overflow-y-auto">
          {menuItems
            .filter(item => !item.adminOnly || isAdmin())
            .map((item) => {
              const Icon = item.icon

              // ── Item com dropdown (children) ──
              if (item.children) {
                const anyChildActive = item.children.some(c => isActive(c.path))
                const isOpen = openDropdowns[item.label] || false
                // Acordeão: abrir um grupo fecha os outros, para o menu caber em telas baixas
                const toggleDropdown = () => setOpenDropdowns(prev => ({ [item.label]: !prev[item.label] }))
                return (
                  <div key={item.label}>
                    <button
                      onClick={toggleDropdown}
                      className={`
                        w-full flex items-center space-x-3 px-4 py-2 rounded-xl transition-all duration-200
                        ${isOpen
                          ? 'bg-white/10 text-white'
                          : 'text-blue-100 hover:bg-blue-700 hover:text-white'
                        }
                      `}
                    >
                      <Icon className="w-5 h-5" />
                      <div className="flex-1 text-left">
                        <p className="font-medium">{item.label}</p>
                        <p className="text-xs text-blue-300 [@media(max-height:820px)]:hidden">{item.description}</p>
                      </div>
                      <ChevronRight className={`w-4 h-4 text-blue-300 transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`} />
                    </button>

                    {isOpen && (
                      <div className="mt-1 ml-4 pl-3 border-l-2 border-blue-600 space-y-1">
                        {item.children.filter(child => !child.ocultoSemAcesso || isAdmin()).map(child => {
                          const childActive = isActive(child.path)
                          const bloqueadoAdmin = child.adminOnly && !isAdmin()
                          const bloqueadoGerente = child.gerenteOuAdmin && !isGerenteOuAdmin()
                          const bloqueado = bloqueadoAdmin || bloqueadoGerente

                          if (bloqueado) {
                            return (
                              <div
                                key={child.path}
                                title={bloqueadoAdmin ? 'Acesso restrito a administradores' : 'Acesso restrito a gerentes e administradores'}
                                className="flex items-center space-x-2 px-3 py-2.5 rounded-lg opacity-50 cursor-not-allowed"
                              >
                                <div className="w-1.5 h-1.5 rounded-full flex-shrink-0 bg-blue-500" />
                                <div>
                                  <p className="text-sm font-medium leading-tight text-blue-200">{child.label}</p>
                                  <p className="text-xs text-blue-400">Acesso restrito</p>
                                </div>
                              </div>
                            )
                          }

                          return (
                            <Link
                              key={child.path}
                              to={child.path}
                              onClick={() => setSidebarOpen(false)}
                              className={`
                                flex items-center space-x-2 px-3 py-2.5 rounded-lg transition-all duration-200
                                ${childActive
                                  ? 'bg-white text-blue-900 shadow-md font-semibold'
                                  : 'text-blue-200 hover:bg-blue-700 hover:text-white'
                                }
                              `}
                            >
                              <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${childActive ? 'bg-blue-600' : 'bg-blue-500'}`} />
                              <div>
                                <p className="text-sm font-medium leading-tight">{child.label}</p>
                                <p className={`text-xs ${childActive ? 'text-blue-500' : 'text-blue-400'}`}>{child.description}</p>
                              </div>
                            </Link>
                          )
                        })}
                      </div>
                    )}
                  </div>
                )
              }

              // ── Item normal ──
              const active = isActive(item.path)
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setSidebarOpen(false)}
                  className={`
                    flex items-center space-x-3 px-4 py-2 rounded-xl transition-all duration-200
                    ${active 
                      ? 'bg-white text-blue-900 shadow-lg transform scale-105' 
                      : 'text-blue-100 hover:bg-blue-700 hover:text-white'
                    }
                  `}
                >
                  <div className="relative">
                    <Icon className={`w-5 h-5 ${active ? 'text-blue-600' : ''}`} />
                    {item.path === '/arquivos-escaneados' && temNovosArquivosScaneados && (
                      <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border border-blue-900" />
                    )}
                  </div>
                  <div className="flex-1">
                    <p className={`font-medium ${active ? 'text-blue-900' : ''}`}>{item.label}</p>
                    <p className={`text-xs [@media(max-height:820px)]:hidden ${active ? 'text-blue-600' : 'text-blue-200'}`}>{item.description}</p>
                  </div>
                </Link>
              )
            })}
        </nav>

        {/* Status WhatsApp + Sair (compacto, sempre visível no rodapé do menu) */}
        <div className="flex-shrink-0 px-4 py-3 border-t border-blue-700">
          <div className="flex items-center gap-2">
            <div
              title={whatsappStatus?.conectado ? 'WhatsApp conectado' : 'WhatsApp desconectado'}
              className={`
                flex-1 min-w-0 flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium
                ${whatsappStatus?.conectado
                  ? 'bg-green-400/20 text-green-300'
                  : 'bg-red-400/20 text-red-300'
                }
              `}
            >
              {whatsappStatus?.conectado ? (
                <Wifi className="w-4 h-4 flex-shrink-0" />
              ) : (
                <WifiOff className="w-4 h-4 flex-shrink-0" />
              )}
              <span className="truncate">WhatsApp {whatsappStatus?.conectado ? 'conectado' : 'desconectado'}</span>
            </div>
            <button
              onClick={handleLogout}
              title="Sair do Sistema"
              className="flex items-center gap-1 px-3 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors shadow-lg"
            >
              <LogOut className="w-4 h-4" />
              <span className="font-medium">Sair</span>
            </button>
          </div>
          <p className="mt-2 text-[10px] text-blue-300 text-center">
            v1.0.0 © 2025 Sistema de Cobrança
          </p>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Header */}
        <header className="h-20 bg-white border-b border-gray-200 shadow-sm">
          <div className="h-full px-4 lg:px-8 flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => setSidebarOpen(true)} className="lg:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors">
                <Menu className="w-6 h-6" />
              </button>
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  {currentPage?.label || 'Sistema'}
                </h2>
                <p className="text-sm text-gray-500">
                  {new Date().toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="hidden md:flex items-center">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input type="text" placeholder="Buscar..." className="pl-10 pr-4 py-2 w-64 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                </div>
              </div>

              <Link
                to="/ideias"
                title={gestor && ideiasPendentes > 0 ? `Caixa de Ideias — ${ideiasPendentes} nova(s) para avaliar${ideiasNaoLidas ? ' (não lidas)' : ''}` : 'Caixa de Ideias — envie sua sugestão'}
                className={`relative p-2 rounded-lg transition-colors ${isActive('/ideias') ? 'bg-amber-50 text-amber-600' : 'text-gray-600 hover:bg-amber-50 hover:text-amber-600'}`}
              >
                <Lightbulb className="w-5 h-5" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-green-500 rounded-full"></span>
                {gestor && ideiasPendentes > 0 && (
                  <span className={`absolute bottom-1 right-1 w-2 h-2 bg-red-500 rounded-full ${ideiasNaoLidas ? 'animate-pulse' : ''}`}></span>
                )}
              </Link>

              <button className="relative p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors">
                <Bell className="w-5 h-5" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </button>

              <div className="relative">
                <button onClick={() => setUserMenuOpen(!userMenuOpen)} className="flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <User className="w-5 h-5 text-white" />
                  </div>
                  <div className="hidden md:block text-left">
                    <p className="text-sm font-medium text-gray-900">{usuario?.username || 'Usuário'}</p>
                    <p className="text-xs text-gray-500">{usuario?.email || 'Sem email'}</p>
                  </div>
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                </button>

                {userMenuOpen && (
                  <>
                    <div className="fixed inset-0 z-10" onClick={() => setUserMenuOpen(false)} />
                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
                      <div className="px-4 py-3 border-b border-gray-100">
                        <p className="text-sm font-medium text-gray-900">{usuario?.nome_completo || usuario?.username}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{usuario?.email || 'Sem email'}</p>
                        {isAdmin() && (
                          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-700 mt-2">
                            <Shield className="w-3 h-3" />Administrador
                          </span>
                        )}
                      </div>
                      <button onClick={handleAbrirModalSenha} className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                        <Key className="w-4 h-4 mr-3" />Trocar Senha
                      </button>
                      <Link to="/configuracoes" className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" onClick={() => setUserMenuOpen(false)}>
                        <Settings className="w-4 h-4 mr-3" />Configurações
                      </Link>
                      <button onClick={() => { setUserMenuOpen(false); handleLogout() }} className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 border-t border-gray-100">
                        <LogOut className="w-4 h-4 mr-3" />Sair
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-4 lg:p-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}